import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color: string;
}

export const IconEmail = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.333 14.1667H4.66634C2.23301 14.1667 0.833008 12.7667 0.833008 10.3333V5.66667C0.833008 3.23334 2.23301 1.83334 4.66634 1.83334H11.333C13.7663 1.83334 15.1663 3.23334 15.1663 5.66667V10.3333C15.1663 12.7667 13.7663 14.1667 11.333 14.1667ZM4.66634 2.83334C2.75967 2.83334 1.83301 3.76 1.83301 5.66667V10.3333C1.83301 12.24 2.75967 13.1667 4.66634 13.1667H11.333C13.2397 13.1667 14.1663 12.24 14.1663 10.3333V5.66667C14.1663 3.76 13.2397 2.83334 11.333 2.83334H4.66634Z"
          fill={color}
        />
        <path
          d="M7.99953 8.57998C7.43953 8.57998 6.87286 8.40665 6.43953 8.05332L4.35286 6.38665C4.13953 6.21332 4.09953 5.89998 4.27286 5.68665C4.4462 5.47332 4.75953 5.43332 4.97286 5.60665L7.05952 7.27332C7.56619 7.67999 8.42619 7.67999 8.93286 7.27332L11.0195 5.60665C11.2329 5.43332 11.5529 5.46665 11.7195 5.68665C11.8929 5.89998 11.8595 6.21998 11.6395 6.38665L9.55286 8.05332C9.12619 8.40665 8.55953 8.57998 7.99953 8.57998Z"
          fill={color}
        />
      </svg>
    </SvgWrapper>
  );
};
